<script setup>
const steps = [
  { title: '需求沟通', description: '详细了解您的业务需求和技术要求' },
  { title: '方案设计', description: '提供专业的算法解决方案设计' },
  { title: '算法开发', description: '专业团队进行算法定制开发' },
  { title: '测试部署', description: '全面测试并协助部署上线' },
]
const contactUrl = 'https://www.quectel.com.cn/contact?pro=QWxnb1N0b3JlIEFJ566X5rOV6LaF5biC&tagStr=NGExMDllYjU2NDc3OGZjZg&proType=QUnlvIDmlL7lubPlj7A'
</script>

<template>
  <section class="market-customization" aria-labelledby="customization-title">
    <div class="customization-container">
      <h2 id="customization-title">找不到您需要的算法？</h2>
      <p class="customization-description">我们提供算法定制开发服务，根据您的特定需求开发专属AI算法解决方案</p>
      <h3 class="flow-title">算法制定流程</h3>
      <ol class="customization-steps">
        <li v-for="(step, index) in steps" :key="step.title">
          <div class="step-heading"><span class="step-number">{{ index + 1 }}</span><h4>{{ step.title }}</h4></div>
          <p>{{ step.description }}</p>
        </li>
      </ol>
      <a :href="contactUrl" class="customization-contact">咨询定制服务</a>
    </div>
  </section>
</template>

<style scoped>
.market-customization { padding: 64px 0; background: #fff; color: #14233b; }
.customization-container { width: min(1440px, calc(100% - 48px)); margin: 0 auto; text-align: center; }
.customization-container h2 { margin: 0 0 16px; font-size: 24px; line-height: 1.4; font-weight: 600; }
.customization-description { margin: 0 0 32px; font-size: 16px; line-height: 24px; color: #617089; }
.flow-title { margin: 0 0 24px; font-size: 18px; font-weight: 600; line-height: 28px; }
.customization-steps { display: grid; grid-template-columns: repeat(4, minmax(0, 1fr)); gap: 24px; margin: 0 0 32px; padding: 0; list-style: none; text-align: left; }
.customization-steps li { min-width: 0; padding: 24px; border-radius: 12px; background: #f4f7fb; }
.step-heading { display: flex; align-items: center; gap: 8px; margin-bottom: 12px; }
.step-number { display: inline-flex; flex-shrink: 0; justify-content: center; align-items: center; width: 24px; height: 24px; border-radius: 50%; background: #ed000c; color: #fff; font-size: 14px; }
.step-heading h4 { margin: 0; font-size: 16px; font-weight: 600; line-height: 24px; }
.customization-steps p { margin: 0; color: #617089; font-size: 14px; line-height: 24px; }
.customization-contact { display: inline-flex; align-items: center; justify-content: center; min-height: 44px; width: 240px; max-width: 100%; border-radius: 4px; background: #ed000c; color: #fff; font-size: 14px; text-decoration: none; }
.customization-contact:hover { background: #cb000a; }
.customization-contact:focus-visible { outline: 3px solid #1478d4; outline-offset: 4px; }
@media (min-width: 768px) { .customization-container h2 { font-size: 26px; } }
@media (min-width: 992px) { .customization-container h2 { font-size: 28px; } }
@media (min-width: 1200px) { .customization-container h2 { font-size: 30px; } }
@media (min-width: 1400px) { .customization-container h2 { font-size: 32px; } }
@media (max-width: 991px) { .customization-steps { grid-template-columns: repeat(2, minmax(0, 1fr)); } }
@media (max-width: 767px) { .market-customization { padding: 40px 0; } .customization-container { width: calc(100% - 32px); } .customization-steps { grid-template-columns: minmax(0, 1fr); gap: 16px; } }
</style>